<template>
    <div>
        <van-cell-group>
            <van-cell :title="data.areashort_name + data.car_code + '/' + data.car_category" size="large"/>
            <van-cell title="单据状态" :value="data.state_name" />
            <van-cell title="接车里程" :value="data.driven_distance + 'KM'" />
            <van-cell title="备注" :label="(data.note==null?'': data.rem.note)+ 'KM'" />
        </van-cell-group>
        <van-cell-group
            v-for="it in data.serviceitems" 
            :key="it.id">
            <van-cell :title="it.repair_service_name" size="large"/>
            <van-cell title="金额" :value="'¥' + it.true_price"/>
            <van-cell title="备注" :label="it.rem"/>
        </van-cell-group>
        <van-cell-group
            v-for="it in data.productitems" 
            :key="it.id">
            <van-cell :title="it.car_products_name" size="large"/>
            <van-cell title="金额" :value="'¥' + (it.true_price * it.qty)"/>
            <van-cell title="备注" :label="it.rem"/>
        </van-cell-group>
    </div>
</template>

<script>
import {
  CellGroup,
  Cell
} from 'vant';

export default {
  name: 'servers',
  props: ['data'],
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell
  },
  data() {
    return {};
  },
  mounted() {
    console.log(this.$router)
    // this.getData()
  }
};
</script>
